import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

// Dev mode: bypass authentication (only in dev builds — import.meta.env.DEV is always false in production)
const isDevAuthDisabled = import.meta.env.DEV && import.meta.env.VITE_DISABLE_AUTH === 'true'

export default function ProtectedRoute() {
  const location = useLocation()
  const auth0 = useAuth0()

  // When auth is disabled, always allow access
  if (isDevAuthDisabled) {
    return <Outlet />
  }

  const { isAuthenticated, isLoading } = auth0

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    // Preserve query params (e.g., Auth0 error messages) when redirecting to login
    const loginPath = location.search ? `/login${location.search}` : '/login'
    return <Navigate to={loginPath} state={{ from: location }} replace />
  }

  return <Outlet />
}
